<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Amis de Mgr Isidore de Souza" />
        <LesAmis/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import LesAmis from './LesAmis.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        LesAmis,
        FooterComp,
    }
}
</script>